import { Box, Flex, Heading, Image, Link, Text } from "@chakra-ui/react";
import { ReactElement, useContext } from "react";
import { FormattedMessage } from "react-intl";
import VueContext from "../vueContext";

export function ContactPersonBasic(): ReactElement {
  const {
    $store: {
      state: {
        partnerInfo: { partnerInfo },
      },
    },
  } = useContext(VueContext);

  const contactPerson = partnerInfo?.contactPerson || {};

  return (
    <Box>
      <Heading as="h4" size="sm" fontWeight="normal">
        <FormattedMessage id="contact.contactPerson.title" />
      </Heading>
      <Flex mt="md" alignItems="center">
        <Box>
          <Box width="5rem" maxHeight="5rem" borderRadius="full" overflow="hidden" mr="sm">
            {contactPerson?.profile?.photo ? (
              <Image
                src={`data:image/png;base64,${contactPerson.profile.photo}`}
                alt={contactPerson.name}
              />
            ) : (
              <svg
                width="100%"
                height="100%"
                className="svg-scale"
                viewBox="0 0 240 240"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0"
                  mask-type="alpha"
                  maskUnits="userSpaceOnUse"
                  x="6"
                  y="10"
                  width="225"
                  height="225"
                >
                  <circle cx="118.5" cy="122.5" r="112.5" fill="#C4C4C4" />
                </mask>
                <g mask="url(#mask0)">
                  <rect width="240" height="240" fill="url(#paint0_radial)" />
                  <path
                    d="M33.7734 274.667C33.7734 274.667 207.28 286.788 206.096 274.662C204.912 262.536 216.505 180.464 200 162.667C181.333 149.333 151.741 148.082 147.781 145.444L147.445 145.218C145.234 143.744 141.996 138.001 143.552 135.693C152.403 122.558 161.189 98.4643 161.189 85.0888C161.189 61.681 142.44 42.6666 119.268 42.6666C96.0967 42.6666 77.3472 61.681 77.3472 85.0888C77.3472 98.4714 86.1318 122.565 94.9862 135.695C96.5409 138.001 93.3025 143.744 91.1137 145.204L90.7305 145.461C86.8044 148.08 60.6584 151.304 46.0051 162.667C14.6643 178.667 34.9493 262.54 33.7734 274.667Z"
                    fill="url(#paint1_linear)"
                  />
                  <path d="M125.572 199.578H129.17V187.274H125.572V199.578Z" fill="#0D485D" />
                  <path
                    d="M129.408 183.372C129.408 182.247 128.495 181.333 127.371 181.333C126.247 181.333 125.334 182.247 125.334 183.372C125.334 184.497 126.247 185.411 127.371 185.411C128.495 185.411 129.408 184.497 129.408 183.372ZM160.087 191.494C160.087 186.799 156.259 182.994 151.536 182.994C146.813 182.994 142.984 186.799 142.984 191.494C142.984 196.187 146.813 199.993 151.536 199.993C156.259 199.993 160.087 196.187 160.087 191.494ZM156.628 191.494C156.628 194.288 154.348 196.555 151.536 196.555C148.723 196.555 146.443 194.288 146.443 191.494C146.443 188.698 148.723 186.431 151.536 186.431C154.348 186.431 156.628 188.698 156.628 191.494Z"
                    fill="#0D485D"
                  />
                  <path
                    d="M142.58 196.192H136.524V183.376H132.834V199.578H140.646L142.58 196.192Z"
                    fill="#0D485D"
                  />
                  <path
                    d="M177.082 196.614C178.166 195.19 178.81 193.416 178.81 191.493C178.81 188.812 177.557 186.426 175.605 184.869L173.751 187.818C174.734 188.74 175.351 190.043 175.351 191.493C175.351 194.288 173.071 196.555 170.258 196.555C169.626 196.555 169.023 196.436 168.465 196.226L166.612 199.173C167.719 199.694 168.952 199.992 170.258 199.992C170.261 199.992 170.263 199.992 170.266 199.992L170.258 200H179.92L181.743 197.1L182.014 196.614H177.082ZM173.991 183.832C172.863 183.286 171.599 182.975 170.26 182.975C165.537 182.975 161.709 186.78 161.709 191.473C161.709 194.187 162.992 196.6 164.986 198.155L166.836 195.212C165.813 194.287 165.168 192.956 165.168 191.473C165.168 188.678 167.447 186.412 170.26 186.412C170.925 186.412 171.558 186.543 172.141 186.774L173.991 183.832Z"
                    fill="#0D485D"
                  />
                </g>
                <defs>
                  <radialGradient
                    id="paint0_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(173.333 154.667) rotate(122.005) scale(100.629)"
                  >
                    <stop stopColor="#F3F3F3" />
                    <stop offset="1" stopColor="#E8EBEC" />
                  </radialGradient>
                  <linearGradient
                    id="paint1_linear"
                    x1="119.716"
                    y1="42.6666"
                    x2="119.716"
                    y2="280.053"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#F3F3F3" />
                  </linearGradient>
                </defs>
              </svg>
            )}
          </Box>
        </Box>

        <Box fontSize="sm" fontWeight={400}>
          <Heading as="h4" fontSize="sm" data-cy="contactPersonName" fontWeight="normal" mb="xs">
            {contactPerson.name}
          </Heading>
          {contactPerson?.profile?.mobilePhone && (
            <Text>
              <Link
                href={`tel:${contactPerson.profile.mobilePhone}`}
                data-cy="contactPersonPhoneNumber"
              >
                {contactPerson.profile.mobilePhone}
              </Link>
            </Text>
          )}
          <Text>
            <a href={`mailto:${contactPerson?.email}`} data-cy="contactPersonEmail">
              {contactPerson.email}
            </a>
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}
